import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationUnitsService } from '../api/organization-units.service';
import { ORGANIZATION_UNITS_KEYS } from './queryKeys';

export function useOrgChartProjects(enabled = true) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: ORGANIZATION_UNITS_KEYS.orgChartProjects(activeOrganizationId ?? ''),
    queryFn: ({ signal }) => organizationUnitsService.getOrgChartProjects(signal),
    staleTime: 60_000,
    enabled: !!activeOrganizationId && enabled,
  });
}
